import { render, staticRenderFns } from "./BadgeBlock.vue?vue&type=template&id=4cf9c55d"
import script from "./BadgeBlock.vue?vue&type=script&lang=js"
export * from "./BadgeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports